'use client';

import { ReactNode } from 'react';
import { CaseStudy } from '../../lib/types';
import CaseStudyHero from '../sections/CaseStudyHero';
import AwardsSection from '../sections/AwardsSection';
import RelatedStudies from '../sections/RelatedStudies';
import Cookies from '../sections/Cookies';

interface RelatedStudy {
  slug: string;
  title: string;
  thumbnail: string;
  thumbnailVideo?: string; // Optional video for thumbnail - uses thumbnail image as fallback
}

interface CaseStudyLayoutProps {
  caseStudy: CaseStudy;
  children?: ReactNode;
  heroColor?: string;
  navInitialTextColor?: 'white' | 'black';
  navTextLock?: 'white' | 'black';
  relatedStudies?: RelatedStudy[];
}

export default function CaseStudyLayout({
  caseStudy,
  children,
  heroColor,
  navInitialTextColor,
  navTextLock,
  relatedStudies
}: CaseStudyLayoutProps) {
  const {
    client,
    title,
    description,
    featuredImage,
    heroVideo
  } = caseStudy;

  return (
    <>
    <CaseStudyHero
      client={client}
      title={title}
      description={description}
      featuredImage={featuredImage}
      heroVideo={heroVideo}
      backgroundColor={heroColor}
      textColor={navInitialTextColor}
    />

      <article 
        className="relative global-padding" 
        data-nav-initial-text={navInitialTextColor}
        data-nav-text-lock={navTextLock}
      >
        <div className="">
          {/* Flexible content area - components can be arranged in any order */}
          <div className="relative bg-transparent">
            <div className="">
              {children}
            </div>
          </div>

          {/* Awards Section - Conditional - renders before RelatedStudies */}
          {caseStudy.awards && (
            <AwardsSection 
              backgroundColor={caseStudy.awards.backgroundColor}
              awards={caseStudy.awards.entries}
            />
          )}

          {/* Related Studies - Conditional - renders after AwardsSection */}
          {relatedStudies && relatedStudies.length > 0 && (
            <RelatedStudies studies={relatedStudies} />
          )}

          <div className="vs-article"></div>

          {/* Cookies */}
          <Cookies />
        </div>
      </article>
    </>
  );
}
